// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--jira-werewolves/jira-space-dashboard-guide';

import { MessageFrontend as createMessageFrontendJiraSpaceDashboardGuide } from '@post-office/browser--jira-werewolves/jira-space-dashboard-guide/placements/in-app-v2/jira-space-dashboard-guide';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type PlacementRenderProps } from '@post-office/browser--jira-werewolves/jira-space-dashboard-guide';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendJiraSpaceDashboardGuide({ messageTemplateId: 'jira-space-dashboard-guide' }),
];

export const RawPlacement: PlacementRendererStage<PlacementRenderProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<PlacementRenderProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<PlacementRenderProps> = RawPlacement;
